import * as React from "react"
import PropTypes from "prop-types"
import Field from "containers/requests/components/Field/Field"
import { Select } from "components-design-system"
import PrimeField from "components/PrimeField/PrimeField"

// styles
import "./RequestBaseFields.scss"

// utils
import { CORE_FIELDS } from "../RequestAllFields/RequestAllFields"
import useGlobalFilterStudies from "utilities/useGlobalFilterStudies"

const RequestBaseFields = ({ requestFormData, onChangeRequest = () => {}, readOnly = false }) => {
  const { studiesSelectItemRender } = useGlobalFilterStudies()

  const getDefaultStudyOptions = () => {
    return requestFormData?.corestudies?.map((study) => {
      return { value: study.id, label: study.study_id }
    })
  }

  const getValue = (key) => {
    const keys = key.split(".")
    const fieldKey = keys.pop()
    const obj = keys.reduce((nestedObj, nestedKey) => nestedObj[nestedKey], requestFormData)
    return obj?.[fieldKey]
  }

  const renderStudiesField = (field) => {
    let value = Array.isArray(requestFormData?.corestudies)
      ? requestFormData.corestudies.map((study) => ({ value: study.id, label: study.study_id }))
      : []
    // TODO: review if need to look at "request_data.study_db_ids"
    if (requestFormData?.request_data?.study_db_ids) value = requestFormData.request_data.study_db_ids

    return (
      <Field
        key="req-base-studies-field"
        label={field.label}
        className="md-field"
      >
        <Select
          options={getDefaultStudyOptions()}
          value={value}
          tagRender={studiesSelectItemRender}
          onChange={null}
          mode="multiple"
          readOnly={readOnly}
          className="studies-select"
        />
      </Field>
    )
  }

  return (
    <div
      className="edit-request-info"
      style={{ width: "100%" }}
    >
      {Object.keys(CORE_FIELDS)
        .filter((key) => CORE_FIELDS[key].base === true)
        .map((key) => {
          const field = CORE_FIELDS[key]
          if (key === "request_data.study_db_ids") return renderStudiesField(field)

          let classNames = ["request-addtl-field"]
          if (field.baseClassName) classNames.push(field.baseClassName)
          return (
            <Field
              key={key}
              label={field.label}
              className={classNames.join(" ")}
            >
              <PrimeField
                schema={{
                  type: field.type,
                  placeholder: field.placeholder,
                  items: field.items,
                }}
                onChange={(val) => onChangeRequest(key, val)}
                readOnly={true}
                defaultValue={getValue(key)}
                className={field.className}
              />
            </Field>
          )
        })}
    </div>
  )
}

RequestBaseFields.propTypes = {
  requestFormData: PropTypes.shape({
    studies: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string,
    req_date: PropTypes.string,
    create_date: PropTypes.string,
    type: PropTypes.string,
    requestor: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
  onChangeRequest: PropTypes.func,
  readOnly: PropTypes.bool,
}

export default RequestBaseFields
